module.exports = __webpack_public_path__ + "img/RIGID TANKER_LHD_THUMB.6c547b6f.jpg";